import React, { useEffect, useState } from 'react';
import { getTransports, createTransport, updateTransport } from '../lib/api';
import { Truck, Plus, Edit2, Search, X } from 'lucide-react';

export default function TransportsPage() {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [form, setForm] = useState({ transport_name: '', contact_number: '' });

  const load = () => {
    setLoading(true);
    getTransports({ search }).then(r => { setData(r.data.transports || []); setLoading(false); }).catch(() => setLoading(false));
  };

  useEffect(() => { load(); }, [search]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editItem) { await updateTransport(editItem._id, form); } else { await createTransport(form); }
      setShowForm(false); setEditItem(null); setForm({ transport_name: '', contact_number: '' }); load();
    } catch (e) { alert(e.response?.data?.detail || 'Error'); }
  };

  return (
    <div className="space-y-4" data-testid="transports-page">
      <div className="flex items-center justify-between">
        <div><h1 className="text-2xl font-bold text-boss-text">Transport Master</h1><p className="text-boss-text-muted text-sm">{data.length} transports</p></div>
        <button onClick={() => { setShowForm(true); setEditItem(null); setForm({ transport_name: '', contact_number: '' }); }} className="flex items-center gap-2 px-4 py-2 bg-boss-violet text-white rounded-lg text-sm font-medium hover:bg-boss-violet-2" data-testid="add-transport-btn"><Plus size={16} /> Add Transport</button>
      </div>

      <div className="relative max-w-md">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-boss-text-muted" />
        <input type="text" placeholder="Search..." value={search} onChange={e => setSearch(e.target.value)} className="w-full pl-9 pr-4 py-2 rounded-lg border border-boss-border text-sm focus:ring-2 focus:ring-boss-violet/30 focus:outline-none" />
      </div>

      {showForm && (
        <div className="bg-white rounded-xl p-6 shadow-sm border border-boss-border">
          <div className="flex items-center justify-between mb-4"><h3 className="font-semibold">{editItem ? 'Edit' : 'Add'} Transport</h3><button onClick={() => setShowForm(false)}><X size={18} /></button></div>
          <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <input required placeholder="Transport Name *" value={form.transport_name} onChange={e => setForm(f => ({...f, transport_name: e.target.value}))} className="px-3 py-2 rounded-lg border border-boss-border text-sm focus:ring-2 focus:ring-boss-violet/30 focus:outline-none" data-testid="transport-name-input" />
            <input placeholder="Contact Number" value={form.contact_number} onChange={e => setForm(f => ({...f, contact_number: e.target.value}))} className="px-3 py-2 rounded-lg border border-boss-border text-sm focus:ring-2 focus:ring-boss-violet/30 focus:outline-none" />
            <button type="submit" className="px-6 py-2 bg-boss-violet text-white rounded-lg text-sm font-medium hover:bg-boss-violet-2">{editItem ? 'Update' : 'Create'}</button>
          </form>
        </div>
      )}

      <div className="bg-white rounded-xl shadow-sm border border-boss-border overflow-hidden">
        <table className="w-full text-sm">
          <thead><tr className="border-b bg-boss-surface-2"><th className="text-left py-3 px-4 font-medium text-boss-text-muted">Transport Name</th><th className="text-left py-3 px-4 font-medium text-boss-text-muted">Contact</th><th className="text-center py-3 px-4 font-medium text-boss-text-muted">Status</th><th className="text-center py-3 px-4 font-medium text-boss-text-muted">Action</th></tr></thead>
          <tbody>
            {loading ? [...Array(3)].map((_, i) => <tr key={i}><td colSpan={4} className="py-3 px-4"><div className="h-4 bg-boss-surface-3 rounded animate-pulse" /></td></tr>) : data.length === 0 ? (
              <tr><td colSpan={4} className="py-12 text-center text-boss-text-muted">No transports found</td></tr>
            ) : data.map(t => (
              <tr key={t._id} className="border-b border-boss-border/50 hover:bg-boss-surface-2/50">
                <td className="py-2.5 px-4 font-medium">{t.transport_name}</td>
                <td className="py-2.5 px-4 font-mono text-xs">{t.contact_number || '---'}</td>
                <td className="py-2.5 px-4 text-center"><span className="inline-block px-2 py-0.5 rounded-full text-xs bg-green-100 text-green-700">Active</span></td>
                <td className="py-2.5 px-4 text-center"><button onClick={() => { setEditItem(t); setForm({ transport_name: t.transport_name, contact_number: t.contact_number || '' }); setShowForm(true); }} className="text-boss-violet hover:underline"><Edit2 size={14} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
